import { useMutation } from 'react-query';
import { albumRequest } from 'src/models/gallery';
import { createAlbum } from 'src/services/gallery';

export default function useCreateAlbum() {
  return useMutation((data: albumRequest) => createAlbum(data));
}
